export default __webpack_public_path__ + "static/media/basic-company-logo_black.877bb80f.svg";